import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_46ba8d0f-50d1-45b0-932d-164e40ecbfdf/artifacts/l81b46nl_K2B_Logo_Final-2.png";

export function HomeNav({ onDemo }) {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", fn, { passive: true });
        return () => window.removeEventListener("scroll", fn);
    }, []);

    const links = [
        { label: "Features", href: "#features" },
        { label: "How It Works", href: "#how-it-works" },
        { label: "Outcomes", href: "#outcomes" },
    ];
    const go = (id) => { setOpen(false); document.querySelector(id)?.scrollIntoView({ behavior: "smooth" }); };

    return (
        <header data-testid="homepage-nav" className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-xl border-b border-slate-100/80 shadow-[0_1px_3px_rgba(0,0,0,0.04)]" : "bg-transparent"}`}>
            <div className="max-w-7xl mx-auto px-6 sm:px-8 flex items-center justify-between h-16 lg:h-[4.5rem]">
                <button onClick={() => go("#hero")} className="flex items-center gap-2.5 group">
                    <img src={LOGO_URL} alt="K2B" className="h-8 w-8" />
                </button>
                <nav className="hidden lg:flex items-center gap-9">
                    {links.map(l => (
                        <button key={l.href} onClick={() => go(l.href)}
                            className="text-[0.825rem] text-slate-500 hover:text-slate-900 transition-colors font-medium tracking-wide" style={{ fontFamily: "Manrope" }}>{l.label}</button>
                    ))}
                </nav>
                <div className="hidden lg:flex items-center gap-3">
                    <button data-testid="nav-login-btn" onClick={() => navigate("/login")}
                        className="text-[0.825rem] font-medium text-slate-500 hover:text-slate-900 px-4 py-2 transition-colors" style={{ fontFamily: "Manrope" }}>Login</button>
                    <button data-testid="nav-demo-btn" onClick={onDemo}
                        className="text-[0.825rem] font-semibold text-white bg-[#4A7AB5] hover:bg-[#3d6596] px-5 py-2.5 rounded-lg transition-all" style={{ fontFamily: "Manrope" }}>Request Demo</button>
                </div>
                <button data-testid="homepage-menu-btn" className="lg:hidden text-slate-600 p-2 -mr-2" onClick={() => setOpen(true)}>
                    <Menu className="h-5 w-5" />
                </button>
            </div>
            {open && (
                <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 z-50 lg:hidden">
                    <div className="absolute inset-0 bg-slate-900/20 backdrop-blur-sm" onClick={() => setOpen(false)} />
                    <motion.div initial={{ x: "100%" }} animate={{ x: 0 }} transition={{ type: "spring", damping: 30, stiffness: 300 }}
                        className="absolute right-0 top-0 bottom-0 w-72 bg-white flex flex-col shadow-2xl">
                        <div className="flex items-center justify-between px-6 h-16 border-b border-slate-100">
                            <span className="font-semibold text-sm text-slate-900" style={{ fontFamily: "Outfit" }}>Menu</span>
                            <button onClick={() => setOpen(false)}><X className="h-5 w-5 text-slate-400" /></button>
                        </div>
                        <div className="flex-1 flex flex-col gap-0.5 p-3">
                            {links.map(l => (
                                <button key={l.href} onClick={() => go(l.href)}
                                    className="text-left text-[0.925rem] text-slate-600 hover:text-slate-900 hover:bg-slate-50 px-4 py-3.5 rounded-lg font-medium" style={{ fontFamily: "Manrope" }}>{l.label}</button>
                            ))}
                        </div>
                        <div className="p-4 space-y-2.5 border-t border-slate-100">
                            <button onClick={() => { setOpen(false); navigate("/login"); }}
                                className="w-full text-[0.875rem] font-medium text-slate-700 border border-slate-200 px-5 py-3 rounded-lg hover:bg-slate-50 transition-colors" style={{ fontFamily: "Manrope" }}>Login</button>
                            <button onClick={() => { setOpen(false); onDemo(); }}
                                className="w-full text-[0.875rem] font-semibold text-white bg-[#4A7AB5] hover:bg-[#3d6596] px-5 py-3 rounded-lg transition-all" style={{ fontFamily: "Manrope" }}>Request Demo</button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </header>
    );
}
